import {
  enumCorePageSize,
  enumFillMode,
  enumPageOrientationOptions,
  enumUnitVal,
  kDPIScreen
} from "../constants";
import { GetStdHeaderHeight } from "../utils/GetStdHeaderHeight";
import { GetStdFooterHeight } from "../utils/GetStdFooterHeight";
import { GetStdMargins } from "../utils/GetStdMargins";
import { QPageProps } from "./QPageProps";
import { QPMJournal } from "./QPMJournal";
import { QRect } from "./QRect";
import { QXMLObject } from "./QXMLObject";
import { StringToBool } from "../utils/StringToBool.js";

export class QPageMgr extends QXMLObject {
  constructor() {
    super();
    this.fPageWidth = null;
    this.fPageHeight = null;
    this.fPageOrientation = null;
    //this.fAutoSizePDF = false;

    this.fMargins = null;
    this.fShowMargins = true;

    this.fHeaderHeight = null;
    this.fFooterHeight = null;
    this.fShowHeaderFooter = true;

    //	this.fOutputMPTemplate = false;
    this.fPMJournal = null;

    this.fBackgroundColor = "#FFFFFF";
    this.fBackgroundColor2 = "#FFFFFF";

    this.fBackgroundFillMode = enumFillMode.solidFill;

    this.fDocMgr = null;
    this.fInPDFModeIndex = -1;

    //this.fMScaleFactor = 1;
  }

  //=================================================================================================
  // Initialize
  InitPageMgr(
    docMgr //objDB,
  ) {
    this.fDocMgr = docMgr;
    this.SetXMLElementName("pagemgr");

    // Default page properties
    var marginRect = GetStdMargins();

    var minPageWidth = Math.floor(11 * kDPIScreen); // this.fPageSizeX
    var minPageHeight = Math.floor(8.5 * kDPIScreen); // this.fPageSizeY

    //	var canvasWidth = minPageWidth;
    //	var canvasHeight = minPageHeight;

    //	this.SetCanvasSize(canvasWidth,canvasHeight);
    this.SetMinPageSize(minPageWidth, minPageHeight);
    this.SetPageMargins(marginRect);

    this.SetHeaderHeight(GetStdHeaderHeight(enumUnitVal.pixels));
    this.SetFooterHeight(GetStdFooterHeight(enumUnitVal.pixels)); //0

    this.SetPageOrientation(enumPageOrientationOptions.landscape);
  }

  GetDocMgr() {
    return this.fDocMgr;
  }

  ClosePageMgr() {
    this.fDocMgr = null;
  }

  SetMinPageSizeFromCore(pageType) {
    var pageX = 0;
    var pageY = 0;

    switch (pageType) {
      case enumCorePageSize.letter:
        pageX = 11;
        pageY = 8.5;
        break;
      case enumCorePageSize.legal:
        pageX = 14;
        pageY = 8.5;
        break;
      case enumCorePageSize.tabloid:
        pageX = 17;
        pageY = 11;
        break;
      case enumCorePageSize.a0:
        pageY = 33.1;
        pageX = 46.8;
        break;
      case enumCorePageSize.a1:
        pageY = 23.4;
        pageX = 33.1;
        break;
      case enumCorePageSize.a2:
        pageY = 16.5;
        pageX = 23.4;
        break;
      case enumCorePageSize.a3:
        pageY = 11.7;
        pageX = 16.5;
        break;
      case enumCorePageSize.a4:
        pageY = 8.27;
        pageX = 11.69;
        break;
    }

    var minPageWidth = Math.floor(pageX * kDPIScreen); // this.fPageSizeX
    var minPageHeight = Math.floor(pageY * kDPIScreen); // this.fPageSizeY
    this.SetMinPageSize(minPageWidth, minPageHeight);
  }

  //==============================================================================
  // Undo/Redo Support
  StartJournal() {
    this.fPMJournal = new QPMJournal();
    this.fPMJournal.InitJournal(this);
  }

  ClearJournal() {
    this.fPMJournal = null;
  }

  GetJournal() {
    var j = this.fPMJournal;
    if (j && j.JournalChanged()) return j;
    else return null;
  }

  JournalPageProps() {
    var pp = this.GetPageProps();
    var j = this.fPMJournal;

    j.JournalPageProps(pp);
  }

  RestoreJournal(aJournal) {
    this.StartJournal();
    aJournal.Restore();
  }

  //=================================================================================================
  // Page and Canvas Sizing (includes margins as well)
  SetMinPageSize(pageWidth, pageHeight) {
    this.fPageWidth = pageWidth;
    this.fPageHeight = pageHeight;
  }

  GetMinPageWidth() {
    return this.fPageWidth;
  }

  GetMinPageHeight() {
    return this.fPageHeight;
  }

  SetPageOrientation(pageOrientation) {
    this.fPageOrientation = pageOrientation;
  }

  GetPageOrientation() {
    return this.fPageOrientation;
  }

  GetBackgroundColor() {
    return this.fBackgroundColor;
  }

  SetBackgroundColor(bkGroundColor) {
    this.fBackgroundColor = bkGroundColor;
  }

  GetBackgroundColor2() {
    return this.fBackgroundColor2;
  }

  SetBackgroundColor2(bkGroundColor) {
    this.fBackgroundColor2 = bkGroundColor;
  }

  GetBackgroundFillMode() {
    return this.fBackgroundFillMode;
  }

  SetBackgroundFillMode(fillMode) {
    this.fBackgroundFillMode = fillMode;
  }

  PGetPageOrientationStr() {
    if (this.fPageOrientation != enumPageOrientationOptions.landscape) return "Portrait";
    else return "Landscape";
  }

  PSetPageOrientationStr(pageOrientation) {
    var v = enumPageOrientationOptions.portrait;
    if (pageOrientation == "Landscape") v = enumPageOrientationOptions.landscape;

    this.SetPageOrientation(v);
  }

  //=================================================================================================
  // Margins
  SetPageMargins(theMargins) {
    this.fMargins = theMargins;
  }

  GetPageMargins() {
    return this.fMargins;
  }

  CloneVerticalMarginsFrom(pageMgr) {
    this.SetHeaderHeight(pageMgr.fHeaderHeight);
    this.SetFooterHeight(pageMgr.fFooterHeight);
  }

  SetPDFModeIndex(pageIndex) {
    this.fInPDFModeIndex = pageIndex;
  }

  PDFModeIndex() {
    return this.fInPDFModeIndex;
  }

  GetPageMarginsInt(includeHeadFoot) {
    var r = new QRect();
    var m = this.fMargins;
    //var mScaleFactor = 1;
    // TORK
    /*
	if (gPublishScaler)
	{
		mScaleFactor = gPublishScaler.GetMasterScaleFactor();
		m = m.MultiplyRect(mScaleFactor);
		m.FloorRect();
	}
	*/

    if (includeHeadFoot) {
      var hh = this.fHeaderHeight; //  * mScaleFactor;
      var fh = this.fFooterHeight; // * mScaleFactor;
      r.InitRect(
        Math.ceil(m.fLeft),
        Math.ceil(m.fTop + hh),
        Math.floor(m.fRight),
        Math.floor(m.fBottom + fh)
      );
    } else
      r.InitRect(
        Math.ceil(m.fLeft),
        Math.ceil(m.fTop),
        Math.floor(m.fRight),
        Math.floor(m.fBottom)
      );

    if (this.fInPDFModeIndex != -1) r.InitRect(0, 0, 0, 0); //r.fRight+r.fLeft,r.fTop+r.fBottom);

    return r;
  }

  SetShowPageMargins(showMargins) {
    this.fShowMargins = showMargins;
  }

  GetShowPageMargins() {
    return this.fShowMargins;
  }

  SetShowHeaderFooter(showHeaderFooter) {
    this.fShowHeaderFooter = showHeaderFooter;
  }

  GetShowHeaderFooter() {
    return this.fShowHeaderFooter;
  }

  //=================================================================================================
  // Header and footer area
  GetHeaderHeight() {
    return this.fHeaderHeight;
  }

  GetFooterHeight() {
    return this.fFooterHeight;
  }

  SetHeaderHeight(height) {
    this.fHeaderHeight = height;
  }

  SetFooterHeight(height) {
    this.fFooterHeight = height;
  }

  //=================================================================================================
  // Load & Save
  OutputToJSON(json) {
    //json = {};
    var orientation = this.PGetPageOrientationStr();
    var pageMargins = this.GetPageMargins();
    var pageSizeX = this.GetMinPageWidth();
    var pageSizeY = this.GetMinPageHeight();
    var showMargins = this.GetShowPageMargins();
    var bkGround = this.GetBackgroundColor();
    var bkGround2 = this.GetBackgroundColor2();

    var bkGroundFillMode = this.GetBackgroundFillMode();

    json["orientation"] = orientation;
    json["pageSize"] = { sizeX: pageSizeX, sizeY: pageSizeY };
    json["margins"] = {
      left: pageMargins.fLeft,
      top: pageMargins.fTop,
      right: pageMargins.fRight,
      bottom: pageMargins.fBottom
    };
    json["showMargins"] = showMargins;
    json["backgroundSettings"] = {
      color: bkGround,
      gradientColor: bkGround2,
      fillMode: bkGroundFillMode
    };

    var headerHeight = this.GetHeaderHeight();
    var footerHeight = this.GetFooterHeight();
    var showHeaderFooter = this.GetShowHeaderFooter();
    json["headerSettings"] = {
      headerHeight: headerHeight,
      footerHeight: footerHeight,
      showHeaderFooter: showHeaderFooter
    };
  }

  LoadFromJSON(json) {
    this.PSetPageOrientationStr(json["orientation"]);

    this.SetMinPageSize(json["pageSize"]["sizeX"], json["pageSize"]["sizeY"]);

    var margins = json["margins"];
    var r = new QRect();
    r.InitRect(margins["left"], margins["top"], margins["right"], margins["bottom"]);
    this.SetPageMargins(r);

    this.SetShowPageMargins(json["showMargins"]);

    if (json["headerSettings"]) {
      this.fHeaderHeight = json["headerSettings"]["headerHeight"];
      this.fFooterHeight = json["headerSettings"]["footerHeight"];
      this.SetShowHeaderFooter(json["headerSettings"]["showHeaderFooter"]);
    }

    var backgroundSettings = json["backgroundSettings"];
    if (backgroundSettings["color"]) this.SetBackgroundColor(backgroundSettings["color"]);

    if (backgroundSettings["gradientColor"])
      this.SetBackgroundColor2(backgroundSettings["gradientColor"]);

    if (backgroundSettings["fillMode"]) this.SetBackgroundFillMode(backgroundSettings["fillMode"]);
    else this.SetBackgroundFillMode(enumFillMode.solidFill);
  }

  OutputSubElements(stream) {
    var orientation = this.PGetPageOrientationStr();
    var pageMargins = this.GetPageMargins();
    var pageSizeX = this.GetMinPageWidth();
    var pageSizeY = this.GetMinPageHeight();
    var showMargins = this.GetShowPageMargins();
    var bkGround = this.GetBackgroundColor();
    var bkGround2 = this.GetBackgroundColor2();

    var bkGroundFillMode = this.GetBackgroundFillMode();

    this.OutputSimpleElement("orientation", orientation, stream);
    this.OutputElementPair("pagesize", pageSizeX, pageSizeY, stream);
    this.OutputElementQuad(
      "margins",
      pageMargins.fLeft,
      pageMargins.fTop,
      pageMargins.fRight,
      pageMargins.fBottom,
      stream
    );
    this.OutputSimpleElement("showmargins", showMargins, stream);
    this.OutputSimpleElement("bcolor", bkGround, stream);

    if (bkGround2 != null) this.OutputSimpleElement("bcolor2", bkGround2, stream);

    this.OutputSimpleElement("bcolormode", bkGroundFillMode, stream);

    var headerHeight = this.GetHeaderHeight();
    var footerHeight = this.GetFooterHeight();
    var showHeaderFooter = this.GetShowHeaderFooter();
    this.OutputElementTriple("headerfooter", headerHeight, footerHeight, showHeaderFooter, stream);
  }

  LoadChildElements(objTree) {
    var orientation = objTree.GetValueForChild("orientation", false);
    this.PSetPageOrientationStr(orientation);
    var valueList = objTree.GetValueListForChild("pagesize", true);
    this.SetMinPageSize(valueList[0], valueList[1]);
    var valueList1 = objTree.GetValueListForChild("margins", true);
    var r = new QRect();
    r.InitRect(valueList1[0], valueList1[1], valueList1[2], valueList1[3]);
    this.SetPageMargins(r);

    var showMargins = objTree.GetValueForChild("showmargins", false);
    if (showMargins != null) this.SetShowPageMargins(StringToBool(showMargins));

    //  var autoSizePDF = objTree.GetValueForChild("autosizepdf", false);
    //  if (autoSizePDF != null)
    //      this.SetAutoSizePDF(StringToBool(autoSizePDF));

    var valueList2 = objTree.GetValueListForChild("headerfooter", false);
    var hh = 0,
      fh = 0;
    var showHF = false;
    if (valueList2 != null) {
      parseInt(valueList[0]);

      hh = parseInt(valueList2[0]);
      fh = parseInt(valueList2[1]);
      showHF = StringToBool(valueList2[2]);
    }
    this.fHeaderHeight = hh;
    this.fFooterHeight = fh;
    this.SetShowHeaderFooter(showHF);

    var bkGroundColor = objTree.GetValueForChild("bcolor", false);
    if (bkGroundColor == null) bkGroundColor = "#FFFFFF";
    this.SetBackgroundColor(bkGroundColor);

    var bkGroundColor2 = objTree.GetValueForChild("bcolor2", false);
    if (bkGroundColor2 != null) this.SetBackgroundColor2(bkGroundColor2);

    var bkGroundFillMode = objTree.GetValueForChild("bcolormode", true);
    if (bkGroundFillMode == null) bkGroundFillMode = enumFillMode.solidFill;
    this.SetBackgroundFillMode(bkGroundFillMode);

    var childList = objTree.GetChildOfTypeList("boxlayout");
    if (childList != null) {
      var docMgr = this.GetDocMgr();
      docMgr.SetLegacyBoxLayoutList(childList);
    }
  }

  //=================================================================================================
  // GetPageProps
  GetPageProps() {
    var pp = new QPageProps();

    pp.fPageWidth = this.GetMinPageWidth();
    pp.fPageHeight = this.GetMinPageHeight();
    pp.fMargins = this.GetPageMargins();
    pp.fPageOrientation = this.GetPageOrientation();
    //  pp.fAutoSizePDF = this.GetAutoSizePDF();
    pp.fShowMargins = this.GetShowPageMargins();
    pp.fHeaderHeight = this.GetHeaderHeight();
    pp.fFooterHeight = this.GetFooterHeight();
    pp.fShowHeaderFooter = this.GetShowHeaderFooter();
    pp.fBackgroundColor = this.GetBackgroundColor();
    pp.fBackgroundColor2 = this.GetBackgroundColor2();
    pp.fBackgroundFillMode = this.GetBackgroundFillMode();

    return pp;
  }
}
